import diagnotics from './diagnotics';

export default {
  namespaced: true,
  modules: {
    diagnotics
  },
};
